import { render, staticRenderFns } from "./WelcomeCardForm.vue?vue&type=template&id=9694c268&scoped=true&"
import script from "./WelcomeCardForm.vue?vue&type=script&lang=js&"
export * from "./WelcomeCardForm.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeCardForm.vue?vue&type=style&index=0&id=9694c268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9694c268",
  null
  
)

export default component.exports